<template>
  <div id="advertisement"></div>
</template>
<script>
export default {
  data () {
    return {}
  },
  mounted () {
  }
}
</script>
<style>
  #advertisement {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin: 34px 0;
    box-sizing: border-box;
  }
  #advertisement > div {
    width: 100% !important;
  }
</style>
